
// 商品页面
const goods = () => import(/* webpackChunkName: "Index" */ '@/views/goodsModule/index')

const goodsRouter = [
    {
      path: '/index',
      redirect: '/admin/home',
      component: () => import('@/views/loginModule/index'),
      children: [
        {
          path: '/admin/goods',
          name: 'brandGoods',
          component: goods,
          meta: {
            title: '品牌主'
          }
        }
      ]
    }
  ]
  export default goodsRouter
  
